module.exports = __webpack_public_path__ + "static/media/expand.e95ebaa1.svg";